import FillFlightGroup from "../types/fillFlightRequest/FillFlightGroup";

const getTotalPassengers = function(passengerGroup : FillFlightGroup): number {
    return (passengerGroup.Adults + passengerGroup.Children + passengerGroup.Infants) * passengerGroup.Total;
}

export { getTotalPassengers };